<tabs-inner-wrap>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <details-section title="Search assignees" [showDetails]="false">
      <div class="container">
        <div class="assignees-content">
          <qai-field class="search-field" label="">
            <qai-icon kind="search" qaiSlot="startIcon" />
            <input qai-input type="text" [(ngModel)]="searchTerm" />
          </qai-field>

          <button
            qai-button
            [shape]="'normal'"
            [kind]="'tertiary'"
            [size]="'medium'"
            [disabled]="isCompleted || simulationsCount == 0"
            (click)="handleAddUserToAssignmentClick()"
          >
            Add users to assignment
          </button>
        </div>

        <div class="table-wrapper" [class.completed-assignment]="isCompleted">
          <ng-container *ngIf="displayedTableData.length > 0; else noData">
            <qai-table
              [headers]="headers"
              [data]="displayedTableData"
              [striped]="false"
              (rowAction)="onTableRowAction($event)"
              [initialSortColumn]="initialSortColumn"
              [initialSortDirection]="initialSortDirection"
            ></qai-table>
          </ng-container>

          <ng-template #noData>
            <div class="no-data-container">
              <span>No Data Found!</span>
            </div>
          </ng-template>
        </div>
      </div>
    </details-section>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>
  </ng-template>
</tabs-inner-wrap>

<add-users-to-assignment-modal
  [open]="assignmentModalVisible"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  (closeModal)="closeAssignmentModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  (addToAssignmentClicked)="addToAssignment()"
  [currentAssignees]="currentAssigneesList"
  [isCreateAssignmentFlow]="false"
></add-users-to-assignment-modal>
